<template>
  <div class="pb-40 box grow scrollable">
    <div class="sticky">
      <el-row :gutter="20" class="">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <HeaderCard :title="headerTitle" :col="12" :showAddButton="false"></HeaderCard>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="text-right">
          <!-- <el-card> -->
            <el-row>
              <!-- Sauvegarde -->
              <el-col>
                  <el-button type="primary" size="small" @click="save()">Sauvegarder</el-button>
                  <el-button size="small" @click="back()">Annuler</el-button>

                  <!-- <el-button size="small" class="ml-10" icon="el-icon-delete" @click="handleDeleteProduct"></el-button> -->
              </el-col>
            </el-row>
          <!-- </el-card> -->
        </el-col>
      </el-row>
    </div>
    <div class="list box grow card-shadow--small bg-white p-10">
      <el-form label-position="top"  :model="model" :rules="rules" ref="itemForm" >
        <el-row :gutter="20" class="mb-10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Compagnies actives">
              <el-select
                v-model="model.portausCompanies"
                multiple
                value-key="id"
                placeholder="Sélectionner des compagnies"
                size="small"
                style="width:100%">
                <el-option
                  v-for="pc in allPortausCompanies"
                  :key="pc.id"
                  :label="pc.name"
                  :value="pc">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <CMSViewEditor
          @update="handleCmsUpdate"
          :id="model.id"
          :published="model.published"
          :publishedDate="model.publishedDate"
          :erpProduct="model"
          :cmsName="model.cmsName"
          :slug="model.slug"
          :contents="model.contents"
          :webSite="model.webSite"
          :category="model.category"
          :specificCategory="model.specificCategory"
          :image="model.image"
          :galeries="model.galeries"
          :attributes="model.attributes"
          :origins="model.origins"
          :items="model.items"
          :cmsProvider="model.cmsProvider"
          :relatedProducts="model.relatedProducts"/>
      </el-form>
    </div>
  </div>
</template>
<script>

import productAPI from '@/services/API/product'
import { mapActions, mapState, mapGetters } from 'vuex';
import CMSViewEditor from '@/views/pages/settings/inventories/components/cms-view-editor'
import HeaderCard from '@/components/header-card'

export default {
	name: 'Product-Editor',
	data() {
		return {
      loading: false,
      productLoading : false,
      model : {
        id : null,
        type : 1,
        active : true,
        variableRate : false,
        commissionAccount : null,
        shortDescription : null,
        description : null,
        ean : null,
        provider : null,
        format : null,
        height : null,
        isbn : null,
        length : null,
        marginRate: null,
        mpn : null,
        name : null,
        purchaseAccount : null,
        purchaseUnitPrice : null,
        quantities : [],
        reorderLevel : null,
        returnable : null,
        saleAccount : null,
        sellingUnitPrice :null,
        sku : null,
        tags : [],
        taxable : true,
        taxes : [],
        unit :1,
        upc : null,
        uvc : null,
        volume : null,
        webLink : null,
        weight: null,
        width : null,
        itemRate : null,
        agencyRate : null,
        cmsName: null,
        slug: null,
        contents: [],
        webSite: null,
        category: null,
        specificCategory: null,
        attributes: [],
        origins: [],
        aliasName: null,
        items : [],
        image : null,
        galeries: [],
        cmsProvider: null,
        published: null,
        publishedDate: null,
        relatedProducts: [],
        portausCompanies: [],
      },
      rules : {
        erpProduct : [
          { required: true, message: 'Veuillez sélectionner un produit', trigger: 'blur' }
        ],
        specificType : [
          { required: true, message: 'Veuillez sélectionner un type de produit', trigger: 'blur' }
        ],
      },
      editorOptions: {
        placeholder:"Saisir du contenu...",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link']
					]
				}
			},
		}
	},
  components : {
    HeaderCard,
    CMSViewEditor,
  },
  computed : {
    allPortausCompanies () {
      return this.$store.state.controlData.portausCompanies || [];
    },
    productTypeId () {
      return _.get(this.model, 'type.id');
    },
    headerTitle () {
      return this.isEditionMode ? this.$i18n.t('CMSProduct.edit_product_title') : this.$i18n.t('CMSProduct.new_product_title');
    },
    isEditionMode() {
      return this.productId != null;
    },
		productId(){
			return this.$route.params.productId!=null ? parseInt(this.$route.params.productId) : null;
		},
  },
  methods : {
    handleCmsUpdate (props) {
      _.forIn(props,  (value, key) => {
        if (key === 'category' || key === 'specificCategory' || key === 'image') {
          this.$set(this.model, key, value);
        } else {
          this.model[key] = value;
        }

      })
    },
    save () {
      this.loading = true;
      this.updateProduct( {productToUpdate: this.model, extendedObjects: ['contents', 'items', 'attributes', 'cmsProvider', 'origins', 'relatedProducts'] })
        .then(() => {
          this.loading = false;
          this.$message.success('La fiche produit a été sauvegardée avec succès!')
          this.back();
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.status === 409) {
            // erreur de slug
            this.$message.error(`Le champs slug n'est pas unique. Veuillez spécifier une nouvelle valeur.`);
          } else {
            this.$message.error(`Oups... une erreur s'est produit lors de la modification du produit. Veuillez réessayer plus tard.`);
          }

        })
    },
    getProductDefinition(productId){
      this.productLoading=true;
      return productAPI.getProductDefinitionV2(productId)
        .then((product)=>{
          this.productLoading=false;
          return product;
        })
    },
    setModel (product){
      Object.assign(this.model, product);
      // Reconcile portausCompanies with full objects from controlData
      this.model.portausCompanies = [];
      _.forEach(product.portausCompanies, pc => {
        const found = _.find(this.allPortausCompanies, c => c.id === pc.id);
        if (found) {
          this.model.portausCompanies.push(found);
        } else {
          this.model.portausCompanies.push({ id: pc.id });
        }
      });
    },
    reset () {
      this.$refs.itemForm.resetFields();
      this.model.id = null;
      this.model.type = 1;
      this.model.active = true;
      this.model.variable_rate = false;
      this.model.commissionAccount = null;
      this.model.description = null;
      this.model.shortDescription = null;
      this.model.ean = null;
      this.model.provider = null;
      this.model.format = null;
      this.model.height = null;
      this.model.isbn = null;
      this.model.length = null;
      this.model.marginRate= null;
      this.model.mpn = null;
      this.model.name = null;
      this.model.provider = null;
      this.model.purchaseAccount = null;
      this.model.purchaseUnitPrice = null;
      this.model.quantities = [];
      this.model.reorderLevel = null;
      this.model.returnable = null;
      this.model.saleAccount = null;
      this.model.sellingUnitPrice =null;
      this.model.sku = null;
      this.model.tags = [];
      this.model.taxable = true;
      this.model.taxes = [];
      this.model.unit =1;
      this.model.upc = null;
      this.model.uvc = null;
      this.model.volume = null;
      this.model.webLink = null;
      this.model.weight= null;
      this.model.width = null;
      this.model.agencyRate = null;
      this.model.itemRate = null;
      this.model.variableRate= false;
      this.model.cmsName = null;
      this.model.slug = null;
      this.model.contents = [];
      this.model.webSite = null;
      this.model.category = null;
      this.model.specificCategory = null;
      this.model.attributes = [];
      this.model.origins = [];
      this.model.items = [];
      this.model.image = null;
      this.model.galeries = [];
      this.model.published = null;
      this.model.publishedDate = null;
      this.model.relatedProducts = [];
      this.model.portausCompanies = [];
    },
    back(){
      this.$router.go(-1);

    },
    ...mapActions('products',['updateProduct']),
    ...mapActions('controlData', ['fetchPortausCompany']),
  },
  mounted(){
    this.reset();
    this.fetchPortausCompany();
    if(this.productId !== null){
      return this.getProductDefinition(this.productId)
        .then(product=>{
          this.setModel(product);
        })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
